import { style } from '@vanilla-extract/css';

export const input = style({
  '::placeholder': {
    color: 'var(--placeholder-color)',
  },
});
